import { ServerCommunicationUtil } from '../../../../utils/server_communication_util';
import LanguageRegionCode from '@alltrails/shared/types/LanguageRegionCode';

const createReactClass = require('create-react-class');

const ADMIN_PHOTOS_PER_PAGE = 500;

// mod ok with -ve numbers
const mod = (x, m) => {
  return ((x % m) + m) % m;
};

const PhotoAdminTool = createReactClass({
  getInitialState() {
    return {
      visiblePhotoInfo: this.props.photoInfo.slice(0, ADMIN_PHOTOS_PER_PAGE),
      currentPage: 1,
      currentDefaultPhotoId: this.props.currentDefaultId,
      trailVersionId: this.props.trailVersionId,
      photoTransformations: {},
      selectedPhotoIds: {}
    };
  },
  setAsDefault(photoId) {
    // If the photo has a profile-photo edit-item, approve that rather than calling set-default
    let url;
    let type;
    const photo = this.state.visiblePhotoInfo.find(function(photo) {
      return photo.id == photoId;
    });
    if (photo && photo.profile_edit_item_id) {
      url = `/edititem/${photo.profile_edit_item_id}?s=A`;
      type = 'get';
    } else {
      const trailSlug = this.photoTrailSlug(photoId);
      if (!trailSlug) return;
      url = `/trail/${trailSlug}/edit/photos/${photoId}/set_default`;
      type = 'POST';
    }
    $.ajax({
      url,
      type,
      success: function(data) {
        if (this.props.trailId) {
          // Clear any profile-photo edit items since they will have been "outvoted" on the server
          const { visiblePhotoInfo } = this.state;
          visiblePhotoInfo.forEach(function(photo) {
            photo.profile_edit_item_id = null;
          });
          this.setState({
            trailVersionId: data.status == 'P' ? data.version : null,
            currentDefaultPhotoId: photoId,
            visiblePhotoInfo
          });
        } else this.setPhotoIsProfile(photoId, true);
      }.bind(this),
      error() {
        alert('There was an error setting the default photo');
      }
    });
  },
  clearAllProfileEditItems() {
    const url = `/trail/${this.props.trailSlug}/edit/photos/clear_all_suggest_default`;
    $.ajax({
      url,
      type: 'POST',
      success: function(data) {
        const { visiblePhotoInfo } = this.state;
        visiblePhotoInfo.forEach(function(photo) {
          photo.profile_edit_item_id = null;
        });
        this.setState({
          visiblePhotoInfo
        });
      }.bind(this),
      error() {
        alert('There was an error clearing the profile-photo edit-items');
      }
    });
  },
  removePhoto(photoId) {
    if (confirm('Are you sure you want to delete this photo from AllTrails?')) {
      const url = `/api/alltrails/photos/${photoId}?key=` + `3p0t5s6b5g4g0e8k3c1j3w7y5c3m4t8i`;
      $.ajax({
        url,
        type: 'delete',
        success() {
          $(`#photo-${photoId}`).remove();
        }
      });
    }
  },
  disassociatePhoto(photoId) {
    // If the photo has a suggest-remote edit-item, approve that rather than calling delete
    let url;
    let type;
    const photo = this.state.visiblePhotoInfo.find(photo => {
      return photo.id == photoId;
    });
    if (photo && photo.remove_edit_item_id) {
      url = `/edititem/${photo.remove_edit_item_id}?s=A`;
      type = 'get';
    } else {
      const trailSlug = this.photoTrailSlug(photoId);
      if (!trailSlug) return;
      url = `/trail/${trailSlug}/edit/photos/${photoId}/remove`;
      type = 'post';
    }

    $.ajax({
      url,
      type,
      success() {
        $(`#photo-${photoId}`).remove();
      }
    });
  },
  rejectPendingEditItem(photoId, edit_item_id, edit_item_type) {
    const url = `/edititem/${edit_item_id}?s=R`;
    $.ajax({
      url,
      success: function(data) {
        // Either update photo to remove the flag for has-pending-remove, or remove it from the displayed list
        if (this.props.trailIdStr == 'pending_hide' && edit_item_type == 'remove') {
          const { visiblePhotoInfo } = this.state;
          const photo = visiblePhotoInfo.find(function(photo) {
            return photo.id == photoId;
          });
          if (photo) {
            photo.remove_edit_item_id = null;
            this.setState({
              visiblePhotoInfo
            });
          }
          $(`#photo-${photoId}`).remove();
        } else {
          const { visiblePhotoInfo } = this.state;
          const photo = visiblePhotoInfo.find(function(photo) {
            return photo.id == photoId;
          });
          if (photo) {
            if (edit_item_type == 'profile') photo.profile_edit_item_id = null;
            else if (edit_item_type == 'remove') photo.remove_edit_item_id = null;
            this.setState({
              visiblePhotoInfo
            });
          }
        }
      }.bind(this)
    });
  },
  acceptAllPendingHides() {
    const edit_item_ids = [];
    const item_ids_to_reject = [];
    this.state.visiblePhotoInfo.forEach(function(photo) {
      if (photo.remove_edit_item_id) {
        if (photo.is_profile) item_ids_to_reject.push(photo.remove_edit_item_id);
        else edit_item_ids.push(photo.remove_edit_item_id);
      }
    });
    const url = '/edititem/hidephotos/accept';
    const data = {
      trail_id: this.props.trailId,
      edit_items: edit_item_ids
    };
    $.ajax({
      url,
      type: 'POST',
      data,
      success(data) {
        if (item_ids_to_reject.length == 0) {
          window.location.reload();
          return;
        }
        const url = '/edititem';
        var data = {
          s: 'R',
          edit_items: item_ids_to_reject
        };
        $.ajax({
          url,
          type: 'POST',
          data,
          success(data) {
            window.location.reload();
          }
        });
      }
    });
  },
  rejectAllPendingHides() {
    const item_ids_to_reject = [];
    this.state.visiblePhotoInfo.forEach(function(photo) {
      if (photo.remove_edit_item_id) {
        item_ids_to_reject.push(photo.remove_edit_item_id);
      }
    });
    const url = '/edititem';
    const data = {
      s: 'R',
      edit_items: item_ids_to_reject
    };
    $.ajax({
      url,
      type: 'POST',
      data,
      success(data) {
        window.location.reload();
      }
    });
  },
  clearProfilePhoto(photoId) {
    const trailSlug = this.photoTrailSlug(photoId);
    if (!trailSlug) return;
    const url = `/trail/${trailSlug}/edit/photos/clear_default`;
    $.ajax({
      url,
      type: 'POST',
      success: function(data) {
        if (this.props.trailId)
          this.setState({
            trailVersionId: data.status == 'P' ? data.version : null,
            currentDefaultPhotoId: null
          });
        else this.setPhotoIsProfile(photoId, false);
      }.bind(this)
    });
  },
  rotatePhoto(photoId, angle) {
    const { photoTransformations } = this.state;
    const angle_was = photoTransformations[photoId] && photoTransformations[photoId].angle ? photoTransformations[photoId].angle : 0;
    photoTransformations[photoId] = {
      processing: true,
      angle: angle_was + angle
    };
    this.setState({ photoTransformations });

    const url = `/api/alltrails/photos/${photoId}/rotate`;
    const params = {
      key: ServerCommunicationUtil.apiKey,
      angle
    };
    $.ajax({
      url,
      data: params,
      success: function(data) {
        const { photoTransformations } = this.state;
        photoTransformations[photoId] = { angle: angle_was + angle };
        this.setState({ photoTransformations });
      }.bind(this),
      error: function() {
        const { photoTransformations } = this.state;
        photoTransformations[photoId] = { angle: angle_was };
        this.setState({ photoTransformations });
      }.bind(this)
    });
  },
  loadMore() {
    const currentPage = this.state.currentPage + 1;
    const photoInfo = this.props.photoInfo.slice(0, currentPage * ADMIN_PHOTOS_PER_PAGE);
    this.setState({
      visiblePhotoInfo: photoInfo,
      currentPage
    });
  },
  photoTrailSlug(photoId) {
    if (this.props.trailSlug) return this.props.trailSlug;
    const photo = this.props.photoInfo.find(function(photo) {
      return photo.id == photoId;
    });
    if (photo) return photo.slug;
    return null;
  },
  setPhotoIsProfile(photoId, is_profile) {
    const { visiblePhotoInfo } = this.state;
    const photo = visiblePhotoInfo.find(function(photo) {
      return photo.id == photoId;
    });
    if (photo) {
      photo.is_profile = is_profile;
      this.setState({
        visiblePhotoInfo
      });
    }
  },
  loadPage(page, sort) {
    const trail_id = this.props.trailIdStr || this.props.trailId;
    const page_part = page ? `&page=${page}` : '';
    window.location = `/contribute/admin/photos?trail_id=${trail_id}${page_part}&sort=${sort}`;
  },
  togglePhoto(photoId) {
    const { selectedPhotoIds } = this.state;
    if (selectedPhotoIds[photoId]) delete selectedPhotoIds[photoId];
    else selectedPhotoIds[photoId] = true;
    this.setState({ selectedPhotoIds });
  },
  bulkButton(action) {
    const { selectedPhotoIds } = this.state;
    switch (action) {
      case 'all':
        this.state.visiblePhotoInfo.forEach(function(photo) {
          selectedPhotoIds[photo.id] = true;
        });
        this.setState({ selectedPhotoIds });
        break;
      case 'none':
        this.setState({ selectedPhotoIds: {} });
        break;
      case 'remove':
        if (confirm('Are you sure you want to remove these photos from this trail?')) this.removeOrDeleteNextPhoto(action);
        break;
      case 'delete':
        if (confirm('Are you sure you want to delete these photos from AllTrails?')) this.removeOrDeleteNextPhoto(action);
        break;
      default:
        break;
    }
  },
  removeOrDeleteNextPhoto(action) {
    // NOTE this function is called recursively so as to sequentially run the potentially
    // large number of API calls.  It clears the next photo in the queue whether it succeeds
    // or not to avoid infinitely retrying the same one.
    const { selectedPhotoIds } = this.state;
    const photoIds = Object.keys(selectedPhotoIds);
    if (photoIds.length) {
      const photoId = photoIds[0];
      let url;
      let type;
      if (action === 'delete') {
        url = `/api/alltrails/photos/${photoId}?key=3p0t5s6b5g4g0e8k3c1j3w7y5c3m4t8i`;
        type = 'delete';
      } else {
        url = `/trail/${this.props.trailSlug}/edit/photos/${photoId}/remove`;
        type = 'post';
      }

      $.ajax({
        url,
        type,
        success: function() {
          $(`#photo-${photoId}`).remove();
          delete selectedPhotoIds[photoId];
          this.removeOrDeleteNextPhoto(action);
        }.bind(this),
        error(xhr, status, error) {
          console.error(xhr.responseText);
          alert('ERROR - see console for more details');
        }
      });
    }
  },
  render() {
    let clearProfilePhotoButton = '';
    const photoDivs = this.state.visiblePhotoInfo.map(
      function(photo) {
        const photoId = photo.id;
        const photoUrl = `/api/alltrails/photos/${photoId}/image?size=large&api_key=${ServerCommunicationUtil.apiKey}`;
        let selectedClass = '';
        let buttons = '';
        if (this.props.trailId && photoId == this.state.currentDefaultPhotoId) {
          selectedClass = 'selected';
          clearProfilePhotoButton = <button onClick={this.clearProfilePhoto.bind(null, photoId)} data-testid="clearProfilePhoto">Clear Profile Photo</button>;
          let clearProfileEditItemsButton = null;
          let profileEditItemsCount = 0;
          const { visiblePhotoInfo } = this.state;
          this.state.visiblePhotoInfo.forEach(
            function(photo1) {
              if (photo1.profile_edit_item_id && photo1.id != this.state.currentDefaultPhotoId) profileEditItemsCount++;
            }.bind(this)
          );
          if (profileEditItemsCount > 0) clearProfileEditItemsButton = <button onClick={this.clearAllProfileEditItems} data-testid="keepProfilePhoto">Keep Profile Photo</button>;
          buttons = (
            <div>
              {clearProfilePhotoButton}
              {clearProfileEditItemsButton}
              <input
                type="checkbox"
                checked={this.state.selectedPhotoIds[photoId]}
                className="photo-select"
                value={1}
                onChange={this.togglePhoto.bind(null, photoId)}
                data-testid="selectedPhotoCheckbox"
              />
            </div>
          );
        } else {
          const disabled = this.state.photoTransformations[photoId] && this.state.photoTransformations[photoId].processing;
          let profilePhotoButton;
          if (!this.props.trailId && photo.is_profile) {
            selectedClass = 'selected';
            profilePhotoButton = (
              <button disabled={disabled} onClick={this.clearProfilePhoto.bind(null, photoId)} data-testid="clearProfilePhoto">
                Clear Profile Photo
              </button>
            );
          } else
            profilePhotoButton = (
              <button disabled={disabled} onClick={this.setAsDefault.bind(null, photoId)} data-testId="setAsProfilePhoto">
                Set as Profile
              </button>
            );
          let rejectPendingButton = null;
          if (photo.profile_edit_item_id) {
            selectedClass = 'has-profile-edit-item';
            if (photo.profile_edit_item_is_ml)
              rejectPendingButton = (
                <button disabled={disabled} onClick={this.rejectPendingEditItem.bind(null, photoId, photo.profile_edit_item_id, 'profile')} data-testid="rejectMlSuggest">
                  Reject ML Suggest
                </button>
              );
            else
              rejectPendingButton = (
                <button disabled={disabled} onClick={this.rejectPendingEditItem.bind(null, photoId, photo.profile_edit_item_id, 'profile')} data-testid="rejectSuggest">
                  Reject Suggest
                </button>
              );
          } else if (photo.remove_edit_item_id) {
            selectedClass = 'has-remove-edit-item';
            if (photo.remove_edit_item_is_ml)
              rejectPendingButton = (
                <button disabled={disabled} onClick={this.rejectPendingEditItem.bind(null, photoId, photo.remove_edit_item_id, 'remove')} data-testid="rejectMlRemove">
                  Reject ML Remove
                </button>
              );
            else
              rejectPendingButton = (
                <button disabled={disabled} onClick={this.rejectPendingEditItem.bind(null, photoId, photo.remove_edit_item_id, 'remove')} data-testid="rejectRemove">
                  Reject Remove
                </button>
              );
          }
          buttons = (
            <p>
              {profilePhotoButton}
              <button disabled={disabled} onClick={this.removePhoto.bind(null, photoId)} data-testid="deletePhoto">
                Delete Photo
              </button>
              <button disabled={disabled} onClick={this.disassociatePhoto.bind(null, photoId)} data-testid="removeFromGalleries">
                Remove from Galleries
              </button>
              {rejectPendingButton}
              <button disabled={disabled} onClick={this.rotatePhoto.bind(null, photoId, -90)} data-testid="rotatePhoto">
                Rotate &#x20D4;&nbsp;
              </button>
              <button disabled={disabled} onClick={this.rotatePhoto.bind(null, photoId, 90)} data-testid="rotate90">
                &#x20D5;&nbsp;
              </button>
              <button disabled={disabled} onClick={this.rotatePhoto.bind(null, photoId, 180)} data-testid="rotate180">
                180
              </button>
              <input
                type="checkbox"
                checked={this.state.selectedPhotoIds[photoId]}
                className="photo-select"
                value={1}
                data-testid="selectedPhotoCheckbox"
                onChange={this.togglePhoto.bind(null, photoId)}
              />
            </p>
          );
        }
        let img;
        if (this.state.photoTransformations[photoId] && this.state.photoTransformations[photoId].hasOwnProperty('angle')) {
          let className = `r${mod(this.state.photoTransformations[photoId].angle, 360)}`;
          if (this.state.photoTransformations[photoId].processing) className += ' blurry';
          img = <img src={photoUrl} className={className} />;
        } else img = <img src={photoUrl} />;
        let info = null;
        let count_info = null;
        let trail_link = null;
        if (photo.trail_id && photo.slug) {
          trail_link = (
            <a href={`/contribute/admin/photos?trail_id=${photo.trail_id}`} target="_blank" data-testid="trailLink">
              {photo.slug}
            </a>
          );
          count_info = <span><b>Photos:</b> {photo.tpcount == null ? '-' : photo.tpcount}</span>;
        } else if (this.props.trailId && photoId != this.state.currentDefaultPhotoId) {
          trail_link = (
            <a href={`/trail/${this.props.trailSlug}?p=${photo.id}`} target="_blank" data-testid="previewAsProfile">
              Preview as profile
            </a>
          );
        }
        const trailLinkList = (trails, linkExcept) =>
          trails.map((trail, i) => [
            i > 0 && ', ',
            linkExcept === trail.trail_id ? trail.trail_id : <a href={`/trail/${trail.slug}`}>{trail.trail_id}</a>
          ]);
        const profile = photo.ml_qs_profile == null ? '-' : photo.ml_qs_profile;
        const hidden = photo.ml_qs_hidden == null ? '-' : photo.ml_qs_hidden;
        const resolution = photo.width >= 800 && photo.height >= 600 ? 'High' : `${photo.width} x ${photo.height}`;
        const latLng = photo.lat_lng ? photo.lat_lng.join(',') : '-';
        const aspectRatio = photo.aspect_ratio.toFixed(3);
        const geoPhotoOnTrails = trailLinkList(photo.geo_photo_on_trails, this.props.trailId);
        const profilePhotoOnTrails = trailLinkList(photo.profile_photo_on_trails, this.props.trailId);
        const meetsMqs = photo.meets_mqs ? 'Yes' : 'No';
        const createdAt = new Date(photo.created_at).toLocaleDateString(LanguageRegionCode.English);

        info = (
          <p>
            <b>Profile:</b>
            {profile}% <b>Hidden:</b>
            {hidden}% <b>Resolution:</b>
            {resolution} <b>MQS:</b>
            {meetsMqs} <b>Loc:</b>
            {latLng} <b>Aspect:</b>
            {aspectRatio} <b>GeoTrails:</b>
            {geoPhotoOnTrails} <b>ProfileOn:</b>
            {profilePhotoOnTrails} <b>Date:</b>
            {createdAt} {count_info}
            {trail_link}
          </p>
        );
        return (
          <div className={`photo-cell ${selectedClass}`} key={`photo-${photoId}`} id={`photo-${photoId}`}>
            <a name={`photo_${photoId}`} />
            {img}
            {info}
            {buttons}
          </div>
        );
      }.bind(this)
    );
    let trailUrl = `/trail/${this.props.trailSlug}`;
    if (this.state.trailVersionId) trailUrl += `?version=${this.state.trailVersionId}`;
    const selected = Object.keys(this.state.selectedPhotoIds).length;
    const selectButtons = (
      <div>
        <button disabled={selected == this.state.visiblePhotoInfo.length} onClick={this.bulkButton.bind(null, 'all')} data-testid="selectAll">
          Select all
        </button>
        <button disabled={selected == 0} onClick={this.bulkButton.bind(null, 'none')} data-testid="selectNone">
          Select none
        </button>
        <button disabled={selected == 0} onClick={this.bulkButton.bind(null, 'delete')} data-testid="deleteBtn">
          Delete {selected}
        </button>
        <button disabled={selected == 0} onClick={this.bulkButton.bind(null, 'remove')} data-testid="removeBtn">
          Remove {selected}
        </button>
      </div>
    );
    let acceptAllPendingHidesButton = null;
    let rejectAllPendingHidesButton = null;
    if (this.props.trailIdStr == null || this.props.trailIdStr == 'pending_hide') {
      acceptAllPendingHidesButton = (
        <span className="contribute-button" onClick={this.acceptAllPendingHides} data-testid="acceptAllHides">
          Accept All Hides
        </span>
      );
      rejectAllPendingHidesButton = (
        <span className="contribute-button" onClick={this.rejectAllPendingHides} data-testid="rejectAllHides">
          Reject All Hides
        </span>
      );
    }
    const sortButtons = (
      <div>
        <button disabled={this.props.sortBy == 'default'} onClick={this.loadPage.bind(null, this.props.pageNo, 'default')} data-testid="defaultSort">
          Default Sort
        </button>
        <button disabled={this.props.sortBy == 'mlp'} onClick={this.loadPage.bind(null, this.props.pageNo, 'mlp')} data-testid="sortByMLProfile">
          Sort by ML Profile
        </button>
        <button disabled={this.props.sortBy == 'mlh'} onClick={this.loadPage.bind(null, this.props.pageNo, 'mlh')} data-testid="sortByMlHidden">
          Sort by ML Hidden
        </button>
        {acceptAllPendingHidesButton}
        {rejectAllPendingHidesButton}
      </div>
    );
    let pageButtons;
    if (this.props.pageNo) {
      pageButtons = (
        <div>
          <button onClick={this.loadPage.bind(null, parseInt(this.props.pageNo) - 1, this.props.sortBy)} disabled={parseInt(this.props.pageNo) <= 1} data-testid="prevPage">
            Prev Page
          </button>
          <button onClick={this.loadPage.bind(null, parseInt(this.props.pageNo) + 1, this.props.sortBy)} data-testid="nextPage">Next Page</button>
        </div>
      );
    } else {
      pageButtons = (
        <div>
          <button onClick={this.loadMore} data-testid="loadMorePhotos">LOAD MORE PHOTOS</button>
        </div>
      );
    }
    return (
      <div id="photo-admin-tool">
        <div>
          <h1>
            <a href={trailUrl} target="_blank">
              {this.props.trailName}
            </a>
          </h1>
        </div>
        <br />
        {clearProfilePhotoButton} {selectButtons} {sortButtons}
        <br />
        {photoDivs}
        <br />
        {selectButtons}
        <br />
        {pageButtons}
      </div>
    );
  }
});

export { PhotoAdminTool };
